// src/components/pages/Pessoa/tabs/buildPessoaTabs.js

import React from 'react';

import PessoaTabCabecalho from './PessoaTabCabecalho';
import PessoaTabFisica from './PessoaTabFisica';
import PessoaTabDocumentos from './PessoaTabDocumentos';
import PessoaTabJuridica from './PessoaTabJuridica';
import PessoaTabFinanceiro from './PessoaTabFinanceiro';
import PessoaTabTabelaPrecos from './PessoaTabTabelaPrecos';
import PessoaTabEmails from './PessoaTabEmails';
import PessoaTabTelefones from './PessoaTabTelefones';
import PessoaTabEnderecos from './PessoaTabEnderecos';
import PessoaTabNomes from './PessoaTabNomes';
import PessoaTabUsuario from './PessoaTabUsuario';
import PessoaTabColaborador from './PessoaTabColaborador';
import PessoaTabFuncionarios from './PessoaTabFuncionarios';
import PessoaTabFiliais from './PessoaTabFiliais';

export function buildPessoaTabs({
    profile,
    theme,
    modules,
    mrts,

    tabsVisibility,

    consultaDatalist,

    // enums
    EnumTipo,
    EnumVinculoFinanceiro,
    EnumSexo,
    EnumTipoSanguineo,
    EnumEstadoCivil,
    optionsPais,
    EnumCnhCategoria,
    EnumRamoAtividade,
    EnumPJTipo,
    EnumTipoEndereco,
    EnumTipoEmail,
    EnumTipoTelefone,
    EnumOrigem,

    // options
    optionsEmpresa,
    optionsCnhCategoria,

    // localização
    ufs,

    // comuns
    setFlashMessage,
}) {
    return [
        {
            key: 'cabecalho',
            label: 'Pessoa',
            title: 'Informações principais da pessoa',
            enabled: tabsVisibility.cabecalho,
            panel: (
                <PessoaTabCabecalho
                    module={modules.pessoa}
                    profile={profile}
                    imagemModule={modules.imagem}
                    EnumTipo={EnumTipo}
                    EnumVinculoFinanceiro={EnumVinculoFinanceiro}
                    optionsEmpresa={optionsEmpresa}
                />
            ),
        },
        {
            key: 'fisica',
            label: 'Física',
            title: 'Informações da pessoa física',
            enabled: tabsVisibility.fisica,
            panel: (
                <PessoaTabFisica
                    module={modules.fisica}
                    EnumSexo={EnumSexo}
                    EnumTipoSanguineo={EnumTipoSanguineo}
                    optionsPais={optionsPais}
                    EnumEstadoCivil={EnumEstadoCivil}
                />
            ),
        },
        {
            key: 'nomes',
            label: 'Nomes',
            title: 'Histórico de nomes',
            enabled: tabsVisibility.nomes,
            panel: <PessoaTabNomes theme={theme} module={modules.nomes} mrt={mrts.nomes} EnumOrigem={EnumOrigem} />,
        },
        {
            key: 'documentos',
            label: 'Documentos',
            title: 'Documentos da pessoa física',
            enabled: tabsVisibility.documentos,
            panel: <PessoaTabDocumentos module={modules.fisica} optionsCnhCategoria={optionsCnhCategoria} />,
        },
        {
            key: 'juridica',
            label: 'Jurídica',
            title: 'Informações da pessoa jurídica',
            enabled: tabsVisibility.juridica,
            panel: <PessoaTabJuridica module={modules.juridica} EnumRamoAtividade={EnumRamoAtividade} EnumPJTipo={EnumPJTipo} />,
        },
        {
            key: 'financeiro',
            label: 'Financeiro',
            title: 'Informações financeiras',
            enabled: tabsVisibility.financeiro,
            panel: (
                <PessoaTabFinanceiro
                    module={modules.pessoa}
                    setDados={modules.pessoa.setDados}
                    empresaId={modules.pessoa.dados?.empresaId}
                    consultaDatalist={consultaDatalist}
                    optionsFormaCliente={modules.pessoa.optionsFormaCliente}
                    optionsFormaFornecedor={modules.pessoa.optionsFormaFornecedor}
                    optionsConta={modules.pessoa.optionsConta}
                    optionsPCliente={modules.pessoa.optionsPCliente}
                    optionsPFornecedor={modules.pessoa.optionsPFornecedor}
                />
            ),
        },
        {
            key: 'tabelaPrecos',
            label: 'Tabelas de Preço',
            title: 'Tabelas de preço vinculadas à pessoa',
            enabled: tabsVisibility.tabelaPrecos,
            panel: <PessoaTabTabelaPrecos theme={theme} module={modules.tabelaPrecos} mrt={mrts.tabelaPrecos} />,
        },
        {
            key: 'enderecos',
            label: 'Endereços',
            title: 'Endereços da pessoa',
            enabled: tabsVisibility.enderecos,
            panel: (
                <PessoaTabEnderecos
                    theme={theme}
                    module={modules.enderecos}
                    mrt={mrts.enderecos}
                    ufs={ufs}
                    EnumTipoEndereco={EnumTipoEndereco}
                />
            ),
        },
        {
            key: 'emails',
            label: 'e-mails',
            title: 'Emails da pessoa',
            enabled: tabsVisibility.emails,
            panel: (
                <PessoaTabEmails
                    dados={modules.pessoa.dados}
                    theme={theme}
                    mrt={mrts.emails}
                    pessoaEmails={modules.pessoa.pessoaEmails}
                    setPessoaEmail={modules.pessoa.setPessoaEmail}
                    EnumTipoEmail={EnumTipoEmail}
                    setFlashMessage={setFlashMessage}
                />
            ),
        },
        {
            key: 'telefones',
            label: 'Telefones',
            title: 'Telefones da pessoa',
            enabled: tabsVisibility.telefones,
            panel: (
                <PessoaTabTelefones
                    theme={theme}
                    module={modules.telefones}
                    mrt={mrts.telefones}
                    EnumTipoTelefone={EnumTipoTelefone}
                />
            ),
        },

        {
            key: 'usuario',
            label: 'Usuário',
            title: 'Usuário do sistema',
            enabled: tabsVisibility.usuario,
            panel: (
                <PessoaTabUsuario
                    module={modules.usuario}
                    pessoa={modules.pessoa.dados}
                    pessoaEmpresas={modules.pessoa.pessoaEmpresas}
                />
            ),
        },
        {
            key: 'colaborador',
            label: 'Colaborador',
            title: 'Permissões e funções do colaborador',
            enabled: tabsVisibility.colaborador,
            panel: <PessoaTabColaborador module={modules.colaborador} />,
        },
        {
            key: 'funcionarios',
            label: 'Funcionários',
            title: 'Colaboradores vinculados à pessoa',
            enabled: tabsVisibility.funcionarios,
            panel: <PessoaTabFuncionarios theme={theme} module={modules.funcionarios} mrt={mrts.funcionarios} />,
        },
        {
            key: 'filiais',
            label: 'Filiais',
            title: 'Filiais permitidas',
            enabled: tabsVisibility.filiais,
            panel: <PessoaTabFiliais theme={theme} module={modules.filiais} mrt={mrts.filiais} optionsEmpresa={optionsEmpresa} />,
        },
    ];
}
